import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchAdressComponent } from './search-adress/search-adress.component';
import { CreateAddressComponent } from './create-address/create-address.component';
import { CoreModule } from 'src/app/core/core.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { SearchListComponent } from './search-list/search-list.component';
import { AddressEmailAlertComponent } from './address-email-alert/address-email-alert.component';

@NgModule({
  declarations: [
    SearchAdressComponent,
    CreateAddressComponent,
    SearchListComponent,
    AddressEmailAlertComponent,
  ],
  imports: [
    CommonModule,
    CoreModule,
    SharedModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
  ],
})
export class AddressModule {}
